module.exports = __webpack_public_path__ + "static/img/pattern_mini_left_bottom.de9bfb0b.png";